function Header({ title }: { title: string }) {
  return (
    <div className="grid gap-2 text-center">
      <h1 className="text-3xl font-bold">{title}</h1>
    </div>
  )
}

function SubHeader({ title }: { title: string }) {
  return <div className="text-center text-sm text-gray-300">{title}</div>
}

export { Header, SubHeader }
